export interface UserRole {
  role: string;
  Active: number;
}

export class DefaultPages {
  title: string;
  id: number;
  par?: number;
  checked?: boolean;
}

export class RoleAssign {
  [x: string]: any;
  constructor(
    public DefaultPage: number,
    public Active: boolean | number,
    public AccessMenus: AccessOptions,
    public RoleId?: number,
    public RoleName?: string,
    public createdby?: string,
    public updatedby?: string,
    public NewAccessMenuJson?: AccessOptions,
  ) { }
}
export class ExistingRoleAssign {
  constructor(
    public DefaultPage: number,
    public Active: boolean | number,
    public AccessMenus: any,
    public RoleId?: number,
    public RoleName?: string,
    public createdby?: string,
    public updatedby?: string,
  ) { }
}

export interface AccessOptions {
  // btns?: SubMenusOptions;
  // tabs?: PermsOptions;
  [x: number]: number[];
  // [x: number]: PermsOptions;
}

// export interface SubMenusOptions {
//   [x: number]: number[];
// }

export interface PermsOptions {
  [x: number]: any[];
}

export interface RoleListRes {
  status_code: number;
  status: string;
  service_name: string;
  data: RoleListData;
}

export interface RoleListData {
  totalrecord: number;
  records: RoleListRecord[];
}

export interface RoleListRecord {
  RoleId: number;
  RoleName: string;
  Active: number;
}

export interface RoleDetailsRes {
  status_code: number;
  status: string;
  service_name: string;
  data: RoleDetailsData;
}

export interface RoleDetailsData {
  totalrecord: number;
  records: RoleAssign;
}

// export interface RoleDetailsRecord {
//   RoleId: number;
//   RoleName: string;
//   Active: number;
// }

export enum UserRoles {
  Admin = 1,
  Hauiler = 3,
  Customer = 4,
  TypeBCustomer = 101,
  SuperAdmin = 999,
  Driver = 100,
  Commercial = 1009,
  Rfq = 11,
  LLWR = 6
}

export const enum archiveRefName {
  archive = 'archive'
}

export const enum tblPaginator {
  addPageNumber = 1,
  addPageEnd = 9,
  addNoOfRows = 10
}

export enum transportTabs {
  iSOContainers = 1,
  nonISOContainers = 2,
  iSOContainersSupplied = 3,
  nonISOContainersSupplied = 4,
  ancillaryEquipments = 5,
  looseEquipments = 6,
  equipmentHire = 7
}

export enum specialInstruction {
  Yes = 'Yes',
  No = 'No'
}
export enum siteRestrictions {
  Yes = 'Yes',
  No = 'No'
}
